import { CSSFn, styled, StyleProps } from "../../styles"
import { getButtonCss, BaseButtonProps } from "../../Button/ButtonStyles"

interface StyledTriggerProps extends BaseButtonProps, StyleProps {
  css?: CSSFn
}
const StyledTrigger = styled.button<StyledTriggerProps>((props: StyledTriggerProps) => ({
  ...getButtonCss(props),
  display: `flex`,
  alignItems: `center`,
  justifyContent: `space-between`,
  width: `100%`,
  border: `1px solid ${props.theme.palette.grey.dark}`,
  borderRadius: props.theme.borderRadius.sm,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderLeft: `4px solid ${props.theme.palette.brand}`,
  padding: props.theme.spacing(4, 5),
  "&:disabled": {
    backgroundColor: props.theme.palette.grey.light,
    borderColor: props.theme.palette.grey.dark,
    cursor: `not-allowed`,
  },
}))

export default StyledTrigger
